<template>
  <section id="add-user-block" class="case-creation">
    <div class="case-creation__step case-creation__patient-information">
      <div class="case-creation__card">
        <div class="case-creation__heading">
          <div class="title-with-icon">
            <span class="icon">
              <img
                src="@/assets/images/icons/icon-patient-info.svg"
                alt="icon"
                class="img-fluid"
              />
            </span>
            <h3 class="title">
              {{ isNewUser ? "Add User" : "Update User" }}
            </h3>
          </div>
        </div>
        <!-- file name changed -->
        <div class="case-creation__body pb-0">
          <div
            class="vue-form"
            v-loading.fullscreen="loading"
            :element-loading-text="loadingText"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
          >
            <el-form ref="form" v-model="formData">
              <el-row :gutter="30">
                <el-col :span="8">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text">
                        User Type
                        <span class="star">*</span>
                      </label>
                      <el-select
                        placeholder="Select User Type"
                        v-model="formData.user_type"
                        @change="checkUserType"
                        :disabled="!isNewUser"
                        default-first-option
                        
                      >
                        <el-option
                          v-for="(type, index) of userTypes"
                          :key="index"
                          :value="type.value"
                          :label="type.name"
                        ></el-option>
                      </el-select>

                      <p
                        class="err"
                        v-if="
                          getUserAccountErrors && getUserAccountErrors.user_type
                        "
                      >
                        {{ getUserAccountErrors.user_type }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="8" v-if="isHospitalUser">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text">
                        Ordering Facility
                        <span class="star">*</span>
                      </label>
                      <el-select
                        v-model="formData.hospital"
                        placeholder="Select Ordering Facility"
                        @change="fetchAllPhysiciansByHospital"
                        :disabled="isHospitalAdmin() || !isNewUser"
                        :filterable="true"
                        default-first-option
                      >
                        <el-option
                          v-for="(hospital, index) of hospitalsData.data"
                          :key="index"
                          :value="hospital._id"
                          :label="hospital.name"
                        ></el-option>
                      </el-select>
                      <p
                        class="err"
                        v-if="
                          getUserAccountErrors && getUserAccountErrors.hospital
                        "
                      >
                        {{ getUserAccountErrors.hospital }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="8" v-if="isLabUser">
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text">
                        Lab
                        <span class="star">*</span>
                      </label>
                      <el-select
                        v-model="formData.lab"
                        placeholder="Select Lab"
                        @change="setLabDetails"
                        :filterable="true"
                        :disabled="!isNewUser"
                        default-first-option
                        
                      >
                        <el-option
                          v-for="(lab, index) of getAllLabs"
                          :key="index"
                          :value="lab._id"
                          :label="lab.name"
                        ></el-option>
                      </el-select>
                      <p
                        class="err"
                        v-if="getUserAccountErrors && getUserAccountErrors.lab"
                      >
                        {{ getUserAccountErrors.lab }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col
                  :span="8"
                  v-if="formData.user_type === 'HOSPITAL_PHYSICIAN'"
                >
                  <div class="case-creation__input">
                    <el-form-item class="mb-15">
                      <label for="text">
                        Physician
                        <span class="star">*</span>
                      </label>
                      <el-select
                        v-model="formData.physician"
                        placeholder="Select Physician"
                        @change="setPhysicianData"
                        :filterable="true"
                        :disabled="!isNewUser"
                        default-first-option
                        
                      >
                        <el-option
                          v-for="(physician, index) of physiciansData.data"
                          :key="index"
                          :value="physician._id"
                          :label="physician.name"
                        ></el-option>
                      </el-select>
                      <p
                        class="err"
                        v-if="
                          getUserAccountErrors && getUserAccountErrors.physician
                        "
                      >
                        {{ getUserAccountErrors.physician }}
                      </p>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <div
                v-if="(formData.hospital || formData.lab) && formData.user_type"
              >
                <el-row :gutter="40">
                  <el-col :span="8">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <label for="text">
                          First Name
                          <span class="star">*</span>
                        </label>

                        <el-input
                          type="text"
                          v-model="formData.first_name"
                          placeholder="Enter First Name"
                          
                        ></el-input>
                        <span
                          class="err"
                          v-if="
                            getUserAccountErrors &&
                            getUserAccountErrors.first_name
                          "
                          >{{ this.getUserAccountErrors.first_name }}</span
                        >
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <label for="text">
                          Last Name
                          <span class="star">*</span>
                        </label>

                        <el-input
                          type="text"
                          v-model="formData.last_name"
                          placeholder="Enter Last Name"
                          
                        ></el-input>
                        <span
                          class="err"
                          v-if="
                            getUserAccountErrors &&
                            getUserAccountErrors.last_name
                          "
                          >{{ this.getUserAccountErrors.last_name }}</span
                        >
                      </el-form-item>
                    </div>
                  </el-col>

                  <el-col :span="8">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <label for="text">
                          Email
                          <span class="star">*</span>
                        </label>

                        <el-input
                          type="email"
                          class="email-lower"
                          v-model="formData.email"
                          placeholder="Enter Email"
                        ></el-input>
                        <span
                          class="err"
                          v-if="
                            getUserAccountErrors && getUserAccountErrors.email
                          "
                          >{{ this.getUserAccountErrors.email }}</span
                        >
                      </el-form-item>
                    </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <label for="text">
                          Phone
                          <span class="star">*</span>
                        </label>

                        <el-input
                          type="text"
                          v-model="formData.phone"
                          placeholder="Enter Phone"
                          maxlength="10"
                          
                        ></el-input>
                        <span
                          class="err"
                          v-if="
                            getUserAccountErrors && getUserAccountErrors.phone
                          "
                          >{{ getUserAccountErrors.phone }}</span
                        >
                      </el-form-item>
                    </div>
                  </el-col>

                  <el-col :span="8">
                    <div class="case-creation__input">
                      <el-form-item class="mb-15">
                        <label for="text">
                          User Name
                          <span class="star">*</span>
                        </label>

                        <el-input
                          type="text"
                          v-model="formData.username"
                          placeholder="User Name"
                        >
                        </el-input>
                        <template #append>
                          <b>{{ formData.code }}</b>
                        </template>

                        <span
                          class="err"
                          v-if="
                            getUserAccountErrors &&
                            getUserAccountErrors.username
                          "
                          >{{ this.getUserAccountErrors.username }}</span
                        >

                        <span
                          class="err"
                          v-if="
                            getUserAccountErrors &&
                            getUserAccountErrors.critical_error
                          "
                          >{{ this.getUserAccountErrors.critical_error }}</span
                        >
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-form>
          </div>
        </div>
      </div>

      <div class="case-creation__actions">
        <ul class="list">
          <li>
            <button
              type="button"
              class="btn cancel-button"
              @click="cancelUserCreate"
            >
              Cancel
            </button>
          </li>
          <li>
            <button
              v-loading="loading"
              type="button"
              class="btn save-button"
              @click="onSubmit"
              :disabled="loading"
            >
              {{ isNewUser ? "Add Account" : "Update Account" }}
            </button>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import AppHelper from "@/mixins/AppHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  name: "profile",
  mixins: [UserPermissionsHelper, AppHelper],
  computed: {
    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    ...mapGetters("userAccounts", [
      "getUserAccountAddStatus",
      "getUserAccountUpdateStatus",
      "getUserAccountErrors",
      "getUserAccountDataById",
    ]),
    ...mapGetters("labs", ["getAllLabs"]),
    isLabUser() {
      return ["LAB_ADMIN", "LAB_MANAGER"].indexOf(
        this.formData.user_type
      ) > -1
        ? true
        : false;
    },
    isHospitalUser() {
      return [
        "HOSPITAL_ADMIN",
        "HOSPITAL_PHYSICIAN",
        "HOSPITAL_ACCOUNT_MANAGER",
        "ACCOUNT_MANAGER"
      ].indexOf(this.formData.user_type) > -1
        ? true
        : false;
    },
  },

  data() {
    return {
      loading: false,
      isNewUser: true,
      userId: "",
      formData: {
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        username: "",
        user_type: "",
        hospital: "",
        physician: "",
        lab: "",
        code: "",
      },

      userTypes: [
        {
          name: "Lab Manager",
          value: "LAB_MANAGER",
        },
        {
          name: "Physician",
          value: "HOSPITAL_PHYSICIAN",
        },
        {
          name: "Facility Admin",
          value: "HOSPITAL_ADMIN",
        },
        {
          name: "Facility Account Manager",
          value: "HOSPITAL_ACCOUNT_MANAGER",
        },
        {
          name: "Sales Director",
          value: "SALES_DIRECTOR",
        },
      ],
      disableUserAdd: false,
      loadingText: "",
      hospitalsData: {},
      physiciansData: {},
    };
  },
  created() {},
  async mounted() {
    this.userId = this.$route.params.user_id;
    await this.checkAndFetchUser();
    this.checkUserTypeAndFetchData();

    this.refreshErrors();
  },
  methods: {
    convertToLower(value) {
      if (value) {
        this.patientInformationFormData.email = value.toLowerCase();
      }
    },

    async checkUserTypeAndFetchData() {
      if (this.isHospitalAdmin()) {
        // method from mixin
        this.formData.hospital = this.currentUserHospital;
      }
      this.fetchAllHospitals();
      this.fetchLabs();
    },

    async checkAndFetchUser() {
      if (this.userId) {
        this.loading = true;
        this.isNewUser = false;
        this.loadingText = "Fetching data.........";

        await this.$store.dispatch("userAccounts/fetchUserAccountById", {
          id: this.userId,
        });
        let data = { ...this.getUserAccountDataById };
        if (data) {
          this.setUserDetailsInForm(data);
        }
        this.loading = false;
      }
    },

    async refreshErrors() {
      await this.$store.dispatch("userAccounts/refreshErrors");
    },
    fillFields() {},

    async fetchAllHospitals() {
      await this.$store.dispatch("hospitals/fetchAllHospitals", {
        get_all: true,
      });
      this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
    },

    async fetchLabs() {
      await this.$store.dispatch("labs/fetchAllLabs", {
        get_all: true,
      });
    },

    async onSubmit() {
      if (this.isNewUser) {
        await this.addAccount();
      } else {
        await this.updateAccount();
      }
    },
    async addAccount() {
      this.disableUserAdd = true;
      this.loading = true;

      try {
        let params = {
          first_name: this.formData.first_name.trim(),
          last_name: this.formData.last_name.trim(),
          email: this.formData.email.toLowerCase(),
          lab: this.formData.lab,
          phone: this.formData.phone,
          username:
            this.formData.username && this.formData.username.trim()
              ? this.convertToLowerCase(
                  this.formData.username + this.formData.code
                )
              : undefined,
          user_type: this.formData.user_type,
          hospital: this.formData.hospital,
          physician: this.formData.physician
            ? this.formData.physician
            : undefined,
          settings: {
            email_events: [],
          },
        };

        if (this.emailEventsData && this.emailEventsData.length) {
          const userSelectedEvents = this.emailEvents.filter((eventData) => {
            return this.emailEventsData.indexOf(eventData.name) != -1;
          });
          if (userSelectedEvents && userSelectedEvents.length) {
            params["settings"]["email_events"] = userSelectedEvents;
          }
        }

        params = this.getFormattedValues(params);

        await this.$store.dispatch("userAccounts/addUserAccount", params);

        if (this.getUserAccountAddStatus) {
          successNotification("User Account added successfully");
          this.$router.push({
            name: "UserAccounts",
            path: "user-accounts",
          });
        } else if (
          this.getUserAccountErrors &&
          this.getUserAccountErrors.critical_error
        ) {
          errorNotification(this.getUserAccountErrors.critical_error);
        }
      } catch (err) {
        console.log(err);
        this.$notify.error({
          title: "Error",
          message: "Error at Adding user account",
        });
      }
      this.loading = false;
      this.disableUserAdd = false;
    },
    async updateAccount() {
      this.disableUserAdd = true;
      this.loading = true;

      try {
        let params = {
          id: this.userId,
          first_name: this.formData.first_name.trim(),
          last_name: this.formData.last_name.trim(),
          email: this.formData.email.toLowerCase(),
          lab: this.formData.lab,
          phone: this.formData.phone,
          username:
            this.formData.username && this.formData.username.trim()
              ? this.convertToLowerCase(
                  this.formData.username + this.formData.code
                )
              : undefined,
          user_type: this.formData.user_type,
          hospitals: [this.formData.hospital],
          physician: this.formData.physician
            ? this.formData.physician
            : undefined,
          settings: { ...this.getUserAccountDataById.settings },
        };

        if (this.emailEventsData && this.emailEventsData.length) {
          const userSelectedEvents = this.emailEvents.filter((eventData) => {
            return this.emailEventsData.indexOf(eventData.name) != -1;
          });
          if (userSelectedEvents && userSelectedEvents.length) {
            params["settings"]["email_events"] = userSelectedEvents;
          }
        } else {
          params["settings"]["email_events"] = [];
        }

        params = this.getFormattedValues(params);

        await this.$store.dispatch("userAccounts/updateUserAccount", params);

        if (this.getUserAccountUpdateStatus) {
          successNotification("User Account updated successfully");
          this.$router.push({
            name: "HospitalAccountManagers",
          });
        } else if (
          this.getUserAccountErrors &&
          this.getUserAccountErrors.critical_error
        ) {
          errorNotification(this.getUserAccountErrors.critical_error);
        }
      } catch (err) {
        console.log(err);
        this.$notify.error({
          title: "Error",
          message: "Error at Updating user account",
        });
      }
      this.loading = false;
      this.disableUserAdd = false;
    },

    setUserDetailsInForm(data) {
      this.formData.first_name = data.first_name;
      this.formData.last_name = data.last_name;
      this.formData.email = data.email;
      this.formData.lab = data.lab ? data.lab._id : "";
      if (data && data.hospitals && data.hospitals.length) {
        for (let i = 0; i < data.hospitals.length; i++) {
          this.formData.hospital = data.hospitals[i]._id;
        }
      }
      this.formData.physician = data.physician || "";
      this.formData.user_type = data.user_type;
      this.formData.phone = data.phone;
      this.formData.username = data.username;

      if (this.formData.physician) {
        this.loadAllPhysicians(this.formData.hospital);
      }
    },
    cancelUserCreate() {
      this.$confirm(
        "Are you sure want to Cancel Update. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).then(async () => {
        await this.$router.push({
          name: "HospitalAccountManagers",
        });
      });
    },
    async fetchAllPhysiciansByHospital(hospitalId) {
      let selectedHospital = this.hospitalsData.data.find(
        (hospital) => hospital._id == hospitalId
      );
      this.formData.code = "." + selectedHospital.code.toLowerCase();
      this.formData.physician = null;
      await this.loadAllPhysicians(hospitalId);
    },

    async loadAllPhysicians(hospitalId) {
      let params = {
        hospital: hospitalId,
        get_all: true,
      };
      await this.$store.dispatch("physicians/fetchAllPhysicians", params);
      this.physiciansData = JSON.parse(JSON.stringify(this.getAllPhysicians));
    },

    async setLabDetails(labId) {
      let selectedLab = this.getAllLabs.find((lab) => lab._id == labId);
      if (selectedLab.lab_code) {
        this.formData.code = "." + selectedLab.lab_code.toLowerCase();
      }
      this.formData.physician = null;
      this.formData.lab = labId;
    },
    async checkUserType(userType) {
      if (userType === "HOSPITAL_PHYSICIAN") {
        if (this.formData.hospital) {
          await this.fetchAllPhysiciansByHospital(this.formData.hospital);
        }
      }
      this.formData.first_name = "";
      this.formData.last_name = "";
      this.formData.email = "";
      this.formData.phone = "";
      this.formData.username = "";
    },
    setPhysicianData(physicianId) {
      let selectedPhysician = this.physiciansData.data.find(
        (physician) => physician._id == physicianId
      );
      this.formData.first_name = selectedPhysician.name.split(" ")[0];
      this.formData.last_name = selectedPhysician.name.split(" ")[1];
      this.formData.email = selectedPhysician.email;
      this.formData.phone = selectedPhysician.phone;
    },
    convertToLowerCase(data = "") {
      return data.toLowerCase();
    },
  },
};
</script>

<style lang="scss" scoped></style>
